import * as React from 'react'
import styled from 'styled-components'
import { debounce } from 'debounce'
import { Layout } from '@ui/layout'
import { Devices } from '@styles'
import { isClientSide } from '@lib/ssr'
import desktopPageCoverLayer1 from './desktop-page-cover-layer-1.jpg'
import desktopPageCoverLayer2 from './desktop-page-cover-layer-2.png'
import { matchMedia, MediaSource } from '@lib/image-media'
import { useBackgroundOnKroll } from '@lib/use-on-krol'
import { AboutMeDesktop } from './about-me-desktop'
import styles from './about.module.scss'
import { useMemo } from 'react'

const aboutMedia: MediaSource<string>[] = [
  { mediaQuery: Devices.laptop, source: desktopPageCoverLayer1 },
  { mediaQuery: Devices.mobileS, source: '' },
]

export const AboutPage = () => {
  const [pageCover, setPageCover] = React.useState('')
  const showBackground = useBackgroundOnKroll()

  const onResize = React.useCallback(
    debounce(() => setPageCover(matchMedia(aboutMedia, '')), 100),
    [],
  )

  React.useEffect(() => {
    if (isClientSide()) {
      setPageCover(matchMedia(aboutMedia, ''))
      window.addEventListener('resize', onResize)
    }

    return () => {
      if (isClientSide()) {
        window.removeEventListener('resize', onResize)
      }
    }
  }, [])

  const backgroundImage = useMemo(() => {
    switch (pageCover) {
      case desktopPageCoverLayer1:
        return `url(${desktopPageCoverLayer2}), url(${pageCover})`
      default:
        return pageCover
    }
  }, [pageCover])

  return (
    <Layout className={styles.about} showBorder={showBackground} whiteNavigationFont>
      <AboutCover style={{ backgroundImage }} />

      <AboutMeDesktop />
    </Layout>
  )
}

const AboutCover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;

  width: 100vw;
  height: 100vh;

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`
